import { render, staticRenderFns } from "./ResumoCompra.vue?vue&type=template&id=92e4cdf6&scoped=true"
import script from "./ResumoCompra.vue?vue&type=script&lang=js"
export * from "./ResumoCompra.vue?vue&type=script&lang=js"
import style0 from "./ResumoCompra.vue?vue&type=style&index=0&id=92e4cdf6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e4cdf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92e4cdf6')) {
      api.createRecord('92e4cdf6', component.options)
    } else {
      api.reload('92e4cdf6', component.options)
    }
    module.hot.accept("./ResumoCompra.vue?vue&type=template&id=92e4cdf6&scoped=true", function () {
      api.rerender('92e4cdf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components/ResumoCompra.vue"
export default component.exports